const NewToYouSignIn = () => <>To implement</>; // TODO: Implement UI in https://myseek.atlassian.net/browse/DCS-10886

export default NewToYouSignIn;
